<template>
    <div>
        <div class="d-flex justify-content-end">
            <b-button class="align-baseline mr-1" title="Edit" variant="default" @click="showEditModal">
                <font-awesome-icon :icon="['fas', 'pen-to-square']"></font-awesome-icon>
            </b-button>
            <b-button class="align-baseline" title="Delete" variant="default" @click="showDeleteModal">
                <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
            </b-button>
        </div>
        <modal
            :id="deleteModalId"
            title="Delete Subcategory"
            ok-title="Confirm"
            @ok="deleteSubCategory"
            :hide-backdrop="true"
            dialog-class="subcategory-centered-modal"
        >
            Subcategory "{{ params.data.name }}" will be deleted. Are you sure?
        </modal>
        <validation-observer v-slot="{ meta, setValues }" ref="edit_subcategory_form">
            <modal
                ok-title="Save"
                :id="editModalId"
                title="Edit Subcategory"
                @ok.prevent="editSubCategory"
                :ok-disabled="!meta.valid"
                :hide-backdrop="true"
                dialog-class="subcategory-centered-modal"
                @shown="setValues({ name: params.data.name })"
            >
                <validation-provider name="name" v-slot="{ errors, handleChange }" rules="required">
                    <form-input
                        @input="handleChange"
                        :floating-label="labelName"
                        v-model="subCategoryName"
                        :error="errors[0]"
                    ></form-input>
                </validation-provider>
            </modal>
        </validation-observer>
    </div>
</template>

<script>
    import Modal from '../../generic/modal/modal.vue';
    import FormInput from '../../generic/form-input/form-input.vue';
    import API from '../../../api';
    import ResponsiveButton from '../../generic/responsive-button/responsive-button.vue';
    import { PROPERTY_SUBCATEGORY_UPDATE_DELETE_ENDPOINT } from '../../../endpoints';

    export default {
        components: {
            Modal,
            FormInput,
        },
        data() {
            return {
                labelName: 'Category name',
                subCategoryName: null,
            };
        },
        computed: {
            editModalId() {
                return 'subcategory-edit-modal' + this.params.data.id;
            },
            deleteModalId() {
                return 'subcategory-delete-modal' + this.params.data.id;
            },
        },
        created() {
            this.subCategoryName = this.params.data.name;
        },
        methods: {
            showDeleteModal() {
                this.$bvModal.show(this.deleteModalId);
            },
            showEditModal() {
                this.$bvModal.show(this.editModalId);
            },
            async deleteSubCategory() {
                try {
                    await API.delete(PROPERTY_SUBCATEGORY_UPDATE_DELETE_ENDPOINT(this.params.data.id));
                    await this.params.update();
                } catch (e) {
                    this.errorToast({ text: 'Could not delete subcategory' });
                }
            },
            async editSubCategory() {
                try {
                    await API.put(PROPERTY_SUBCATEGORY_UPDATE_DELETE_ENDPOINT(this.params.data.id), {
                        name: this.subCategoryName,
                        labelName: this.labelName,
                    });
                    await this.params.update();
                    this.$bvModal.hide(this.editModalId);
                } catch (e) {
                    this.errorToast({ text: 'Could not update subcategory' });
                } finally {
                    this.busy = false;
                }
            },
        },
    };
</script>

<style lang="scss">
    @import '~bootstrap/scss/_functions.scss';
    @import '~bootstrap/scss/_variables.scss';
    @import '~bootstrap/scss/mixins/_breakpoints.scss';

    .subcategory-centered-modal {
        top: 50px;
        left: 52px;
    }

    @include media-breakpoint-down(sm) {
        .subcategory-centered-modal {
            left: 0;
        }
    }
</style>
